import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React , { Fragment } from 'react';
import dynamic from "next/dynamic";
import Canvas from '../../components/whitepaper/Canvas'
import { useRouter } from 'next/router';
import Config from '../../config';
import { trackPage } from '../../tracking';
import { getPageViewData } from '../../utils/tracking';



const Footer = dynamic(()=> import('../../components/common/Footer'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

export async function getServerSideProps() {
  return {
      props: {
          pageName: 'whitepaper'
      },
  };
}

export default function Home(props) {
  let router = useRouter()
  const BASE_URL = Config.BASE_URL;

  React.useEffect(()=>{
    trackPage('Whitepapers',{...getPageViewData()})
  },[])
  return (
    <Fragment>
      <Head>
        <title>White Paper | Most Common Laptop Issues and Repair Costs | Onsitego</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={"Follow us to get your free copy of the whitepaper and to stay updated on the latest news in technology and electronics."}></meta>
        <meta property="og:title" content={"White Paper | Most Common Laptop Issues and Repair Costs | Onsitego"}/>
        <meta property="og:description" content={"Follow us to get your free copy of the whitepaper and to stay updated on the latest news in technology and electronics."}/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner className="contact-us" title="White Paper - Onsitego">
      </PlainBanner>
      <Canvas />
    </Fragment>
  )
}